import { StorageKey } from './client-storage';
import * as clientStorage from './client-storage';

export function getSingleServeUrl(cbtnUsername?: string | null, redirectLink?: string): any | null {
  const body =
    typeof cbtnUsername === 'string'
      ? JSON.stringify({ cbtnUsername })
      : undefined;
  // Build query params
  const params = new URLSearchParams();
  if (redirectLink) params.append('url', encodeURIComponent(redirectLink));
  if (cbtnUsername) params.append('cbtnUsername', cbtnUsername);

  const url = `${process.env.REACT_APP_API_HOST}/api/v1/programs/ssa/get-single-serve-url${params.toString() ? '?' + params.toString() : ''}`;

  return fetch(url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${clientStorage.get(StorageKey.TOKEN)}`,
    },
    ...(body && { body }),
  })
    .then(async (res) => {
      const response = await res.json();
      if (res.ok) {
        const data = response;
        const singleUseUrl = data.singleUseUrl;
        return singleUseUrl;
      } else {
        console.log('res not okay', response);
        throw new Error(response.message || 'Failed to get single serve URL');
      }
    }).catch(error => {
      console.log('er', error);
      throw error;
    });
}
